import { UsersCharacterIcon } from '@repo/studio-design-system-ui-icons/users/users-character'
import { ROUTES } from '@repo/studio-utils/routes'
import { useStudioTranslate } from '@repo/studio-config/studio-config-context'
import { StudioLayoutLink } from '@repo/studio-config/studio-config-router'
import { tw } from 'utils/classnames'
import { Button } from '@repo/studio-design-system-ui-button'
import { ButtonTooltip } from '@repo/studio-design-system-ui-tooltip'

export function CharactersLink({
  route = ROUTES.CHARACTERS.HOME,
  className,
}: {
  route?: string
  className?: string
}) {
  const t = useStudioTranslate()
  const label = t('studio.home.sidebar.characters')

  return (
    <ButtonTooltip value={label} side="right" delay={0} offset={6} dismissOnContentHover>
      <Button iconOnly asChild variant="ghost" size="sm" aria-label={label}>
        <StudioLayoutLink to={route} className={tw(className)}>
          <UsersCharacterIcon />
        </StudioLayoutLink>
      </Button>
    </ButtonTooltip>
  )
}
